import React from "react";
import "../../../Style/Services/SecendSection.css";

function SecendSection() {
  return (
    <div className="SecendSection">
      <span className="sub-title">
        10 years of experience in Water & Waste Water transfer-Pumping Systems
        for high-rise Residential and commercial buildings & General Industry.
      </span> <br /> <br />
      <h3 className="subtitle-h3">
      'Designed & Developed for Durability, <br />Available across India'
      </h3>
    </div>
  );
}

export default SecendSection;
